export default "__VITE_ASSET__CSL9t3Su__"